import axios, { AxiosResponse } from 'axios';
import { PutLongitudeLatitudeRequest } from 'views/site-settings/features/general-settings/types/put-longitude-latitude-request.type';

// PUT
// /ewosapi/v1/site-settings/{globalSiteId}/location
// Set site location
export const putLongitudeLatitude = async (globalSiteId: string, request: PutLongitudeLatitudeRequest): Promise<AxiosResponse> => {
  return await axios.put(`/ewosapi/v1/site-settings/${globalSiteId}/location`, request);
};
